import ClientActions from '../actions/ClientActions'
import StorePrototype from '../../../shared_components/StorePrototype'

export default StorePrototype(ClientActions.Types.GOT_EMAIL_TEXTS)
